<template>
<v-card class="" tile>

  <v-card-actions class="secondary  white--text py-4">

    <h3>{{title}}</h3>

    <v-spacer></v-spacer>

    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon dark v-on="on">
          <v-icon>fa fa-ellipsis-v</v-icon>
        </v-btn>
         </template>
      <v-list>

        <v-list-item v-if="video && video.approved==0" @click="$emit('update',{video,data:{approved:1}})">
          <v-list-item-title class="green--text">Publish</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="video && video.approved==0" @click="$emit('reject',{video,data:{approved:0}})">
          <v-list-item-title class="red--text">Reject</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="video && video.approved==1" @click="$emit('update',{video,data:{approved:0}})">
          <v-list-item-title class="red--text">Unpublish</v-list-item-title>
        </v-list-item>


        <v-divider v-if="video"></v-divider>
        <v-list-item @click="selectFile">
          <v-list-item-title>Upload Video</v-list-item-title>
        </v-list-item>

        <v-list-item @click="selectThumbnail" v-if="video">
          <v-list-item-title>Upload Thumbnail</v-list-item-title>
        </v-list-item>



      </v-list>
    </v-menu>


  </v-card-actions>

  <!-- Empty !-->
  <div class="video-responsive" v-if="!video && !upload">
    <v-row style="position:absolute;top:0px;bottom:0px;left:0px;right:0px" align="center" justify="center">
      <v-col cols="12" class="text-center">
        <v-icon large v-if="wait_step===1">fa-hourglass-start</v-icon>
        <v-icon large v-if="wait_step===2">fa-hourglass-half</v-icon>
        <v-icon large v-if="wait_step===3">fa-hourglass-end</v-icon>
      </v-col>
    </v-row>
  </div>


  <!-- Uploading !-->
  <div class="video-responsive" v-if="upload">
    <v-row style="position:absolute;top:0px;bottom:0px;left:0px;right:0px" align="center" justify="center">
      <v-col cols="12" class="text-center">
        <v-progress-circular :value="upload.progress" :size="100" :width="8" color="green"> {{ upload.progress }}</v-progress-circular>
      </v-col>
    </v-row>
  </div>

  <!-- Video !-->
  <div class="video-responsive secondary lighten-1" v-if="video && !upload">
    <video :poster="video.thumbnail ? video.thumbnail : null" controls>
  <source :src="video.url">

  Your browser does not support HTML5 video.
    </video>
  </div>

  <!-- Video actions !-->
  <v-card-actions class="grey lighten-3" v-if="video">
    <h5 v-if="video.approved===0" class="blue--text">Pending Review</h5>
    <v-spacer></v-spacer>
    <span class="pull-left mr-2 pt-1 font-weight-bold grey--text text--darken-2" v-if="video">Visible</span>
    <div>
      <v-switch :disabled="true" :true-value="1" :false-value="0" color="green" hide-details class="mt-0" inset dense :input-value="video.visible"></v-switch>
    </div>

  </v-card-actions>

  <input type="file" style="display:none" :id="`file-${random_id}`" @change="handleFileChange($event)" accept="video/*" />
  <input type="file" style="display:none" :id="`image-${random_id}`" @change="handleThumnbailChange($event)" accept="image/*" />
</v-card>
</template>
<script>
export default {
  props: ['title', 'video', 'upload'],
  components: {

  },
  name: "",
  data: () => ({
    random_id: Math.round(Math.random() * 1000000),
    placeholder: '',
    wait_step: 1,
    wait_step_interval: null
  }),
  created() {
    this.wait_step_interval = setInterval(function() {
      this.wait_step = this.wait_step === 1 ? 2 : this.wait_step === 2 ? 3 : 1
    }.bind(this), 2000)
  },
  beforeDestroy() {
    //do something before destroying vue instance
    clearInterval(this.wait_step_interval)
  },
  computed: {

  },
  methods: {
    selectFile() {
      document.querySelector(`#file-${this.random_id}`).click()
    },
    selectThumbnail() {
      document.querySelector(`#image-${this.random_id}`).click()
    },
    handleThumnbailChange(ev) {
      ev.preventDefault();
      let file;
      if (ev.target.files) {
        file = ev.target.files[0]
        this.$emit('thumbnail', {
          video: this.video,
          file: file,
          section: this.video.section
        })
      }
      ev.target.value = null;
    },
    handleFileChange(ev) {
      ev.preventDefault();
      let file;
      if (ev.target.files) {
        file = ev.target.files[0]
        this.$emit('upload', file)
      }
      ev.target.value = null;
    }
  }
}
</script>
<style lang="scss" scoped>
#upload-file {
    display: none;
}
.video-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
}
.video-responsive video {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
}

.highlight {
    animation: grow 0.75s;
    animation-delay: 1s;
    animation-timing-function: ease-in;
}
</style>
